import { supabase } from './supabase';

export interface LoginGuardResult {
  locked: boolean;
  retryAfterSeconds?: number;
}

/**
 * App-level login throttle (edge function `login-guard`): 5 intentos
 * fallidos bloquean la cuenta 15 minutos. Fail-open — cualquier error de
 * red o del propio guard nunca debe bloquear un login legítimo.
 */
async function callLoginGuard(action: 'check' | 'report', email: string, success?: boolean): Promise<LoginGuardResult> {
  try {
    const { data, error } = await supabase.functions.invoke('login-guard', {
      body: { action, email, success },
    });
    if (error || !data) return { locked: false };
    const d = data as { locked?: boolean; retry_after_seconds?: number };
    return { locked: d.locked === true, retryAfterSeconds: d.retry_after_seconds };
  } catch {
    return { locked: false };
  }
}

export const checkLoginGuard = (email: string) => callLoginGuard('check', email);
export const reportLoginGuard = (email: string, success: boolean) => callLoginGuard('report', email, success);
